<h4 *ngIf="label !== ''">{{ label }}</h4>
<div class='dx-field' *ngIf='isSameAsClientControl'>
  <div class='dx-field-value' style='width: auto!important; position: absolute;'>
    <dx-check-box
      [value]='false'
      text='Same as Client'
      [disabled]='IsDisabled'
      [formControl]='isSameAsClientControl'
    ></dx-check-box>
  </div>
</div>
<div class='dx-field' style='width: 100% !important;'>
  <div class='dx-field-label'>
    Address <span class='ocl-required-indicator' *ngIf='required'>*</span>
    <i id='addressIcon' *ngIf='warningIconForRequired && !addressControl.value' class='dx-icon-warning'
       style='font-size: 16px; color: #ff9d09' title='Missing Information'></i>
    <dx-tooltip target='#addressIcon' showEvent='dxhoverstart' hideEvent='dxhoverend'>
      <div *dxTemplate="let data of 'content'">
        Missing information field.
      </div>
    </dx-tooltip>
    <dx-load-indicator
      height='14'
      width='14'
      [(visible)]='isLoading || isLoadingZipCodeExtra'
      style='margin-left: 8px;'
    ></dx-load-indicator>
  </div>
  <div class='dx-field-value' style='width: 100% !important;'>
    <dx-text-box
      class='uppercase'
      [disabled]='disabled || isLoading' [inputAttr]="{autocomplete: 'new-address'}" [width]="'100%'"
      [formControl]='addressControl'>
      <dx-validator [validationGroup]='validationGroup'>
        <dxi-validation-rule *ngIf='required' type='required' message='Address is required'></dxi-validation-rule>
      </dx-validator>
    </dx-text-box>
  </div>
</div>
<div fxLayout='column' fxLayout.sm='row' fxLayoutAlign='space-between'>
  <div fxLayout='row' fxLayout.lt-md='column' fxLayoutAlign='space-between' fxFlex.sm='48%'>
    <div class='dx-field' style='padding-left: 2px!important; padding-right: 2px!important;'
         [ngClass.lt-md]="{paddingLeft: '0', paddingRight: '0'}">
      <div class='dx-field-label'>State</div>
      <div class='dx-field-value'>
        <dx-text-box class='uppercase' [disabled]='true' [ngModel]='state'></dx-text-box>
      </div>
    </div>
    <div class='dx-field' style='padding-left: 2px!important;' [ngClass.lt-md]="{paddingLeft: '0', paddingRight: '0'}">
      <div class='dx-field-label'>City</div>
      <div class='dx-field-value'>
        <dx-text-box class='uppercase' [disabled]='true' [ngModel]='city'></dx-text-box>
      </div>
    </div>
  </div>
  <div fxLayout='row' fxLayout.lt-md='column' fxLayoutAlign='space-between' fxLayoutAlign.lt-md='start'
       fxFlex.sm='48%'>
    <div class='dx-field' style='padding-left: 2px!important; padding-right: 2px!important;'
         [ngClass.lt-md]="{paddingLeft: '0', paddingRight: '0'}">
      <div class='dx-field-label'>ZipCode <span class='ocl-required-indicator' *ngIf='required'>*</span>
        <i id='zipCodeIcon' *ngIf='warningIconForRequired && !zipCodeControl.value' class='dx-icon-warning'
           style='font-size: 16px; color: #ff9d09' title='Missing Information'></i>
        <dx-tooltip target='#zipCodeIcon' showEvent='dxhoverstart' hideEvent='dxhoverend'>
          <div *dxTemplate="let data of 'content'">
            Missing information field.
          </div>
        </dx-tooltip>
      </div>
      <div class='dx-field-value'>
        <dx-text-box
          [disabled]='disabled || isLoading'
          [inputAttr]="{autocomplete: 'new-zipcode'}"
          mask='00000'
          [maskRules]='zipCodeMaskRule'
          (onEnterKey)='calculateAddress()'
          [formControl]='zipCodeControl'
        >
          <dx-validator [validationGroup]='validationGroup'>
            <dxi-validation-rule *ngIf='required' type='required' message='ZipCode is required'></dxi-validation-rule>
          </dx-validator>
        </dx-text-box>
      </div>
    </div>
    <div class='dx-field' style='padding-left: 2px!important; padding-right: 2px!important;'
         [ngClass.lt-md]="{paddingLeft: '0', paddingRight: '0'}">
      <div class='dx-field-label'>ZipCode +4</div>
      <div class='dx-field-value' style='display: inline-flex;'>
        <dx-text-box
          [disabled]='true'
          [formControl]='zipCodeExtraControl'
          style='border-bottom-right-radius: 0 !important;
    border-top-right-radius: 0 !important; width: 100% !important;height: inherit !important;'
        >
          <dx-validator [validationGroup]='validationGroup'>
          </dx-validator>
        </dx-text-box>
        <dx-button
          id='search-btn'
          icon='search'
          (click)='calculateAddress()'
          style='border-bottom-left-radius: 0 !important;
    border-top-left-radius: 0 !important;
    border-left-style: unset !important;
    height: 26px !important;'
        ></dx-button>
      </div>
    </div>
    <div [ngClass.gt-sm]="{paddingRight: '4px'}" fxShow fxHide.xs class='dx-field'></div>
  </div>
</div>
